import React, { Component } from "react";
import FieldError from "./FieldError";
import "./DropDownInputField.scss";

class BooleanInputField extends Component {

  render() {
    const {serverError, label} = this.props;
    const {
      input: {value, onChange},
      meta: {touched, error},
      yesLabel = "Yes",
      noLabel = "No",
    } = this.props;

    let coercedValue = "false";
    if (value === true || value === "true") coercedValue = "true"

    return (
      <tr className="DropDownInputField field">
        <th>{label}</th>
        <td>
          <select
            value={coercedValue}
            onChange={onChange}>
            <option key="yes" value="true">{yesLabel}</option>
            <option key="no" value="false">{noLabel}</option>
          </select>
          <FieldError serverError={serverError} clientError={error} showClientError={touched && error} />
        </td>
      </tr>
    )
  }

  renderErrors() {
    // const {meta: {touched, error}} = this.props;
    const {error, meta: {touched}} = this.props;
    if (touched && error) {
      return <div className="fieldError">{error}</div>
    }
    return null;
  }
}

export default BooleanInputField;


// Boolean input field saved the boolean value as string "true" or "false"
export function coerceBoolean(val) {
  if (val === "true") return true;
  if (val === true) return true;
  return false;
}